import xlsx from 'xlsx'

function exportExcel(data, tableName) {
  const resultWs = xlsx.utils.json_to_sheet(data)
  const wb = xlsx.utils.book_new()

  xlsx.utils.book_append_sheet(wb, resultWs, '-')
  xlsx.writeFile(wb, `${tableName}.xlsx`)
}

function resetForm(parseForm, originalForm) {
  Object.keys(parseForm).map((key) => {
    parseForm[key] = originalForm[key]
    return
  })
}

export { exportExcel, resetForm }
